import React,{useRef,useState,useEffect} from 'react';
import {DataTable,QuotationInfoCard} from '../../Components'
import { Controller, set, useForm } from "react-hook-form";
import { createRoot } from 'react-dom/client';
import { DateFormat,APIURL, DateFormatJSON,DateThaiFormat } from '../../Utils/Function';
import {QuotationType,QuotationTypeName,OrderStatus,OrderStatusList} from '../../Utils/Status';
import Swal from 'sweetalert2';
import API from '../../API';
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from "@fullcalendar/interaction"
import thLocale from '@fullcalendar/core/locales/th';
import {OrderCardInfo} from '../../Components/OrderCard';
import { Calendar } from '@fullcalendar/core/index.js';
import Select from 'react-select';
import { Overlay, Popover } from 'react-bootstrap';

const _StatusLabel = [
    {status:1,  label:'สร้าง',              color:'#6c757d'},
    {status:2,  label:'ส่งใบเสนอราคา',     color:'#6c757d'},
    {status:3,  label:'ติดตาม',             color:'#0d6efd'},
    {status:4,  label:'รอ - Hold',          color:'#0dcaf0'},
    {status:5,  label:'ชำระมัดจำ',         color:'#198754'},
    {status:6,  label:'ยกเลิก - NA',        color:'#dc3545'},
    {status:7,  label:'รอชำระมัดจำ',       color:'#ffc107'},
    {status:9,  label:'ยกเลิก - DN',        color:'#dc3545'},
    {status:10, label:'จบงาน',              color:'#20c997'},
];

const PageCalendar =()=> {
    const { register, getValues, setValue } = useForm();
    const [_EventList,setEventList] = useState([]);
    const [_DateInfo,setDateInfo] = useState(null);
    const [_CalendarType,setCalendarType] = useState(0);
    const [_AccountType,setAccountType] = useState(['1','2']);
    const [_CalendarStatus,setCalendarStatus] = useState(0);
    const _QuotationInfoCard = useRef();
    const _OrderInfoCard = useRef();
    const _CalendarRef = useRef();
    const [_CalendarView,setCalendarView] = useState('dayGridMonth');
    const [_QuotationType,setQuotationType] = useState(()=>QuotationType.map(v=>String(v)));
    const [_OrderStatusList,setOrderStatusList] = useState([]);
    const _OrderStatusOptions = OrderStatusList.map(v=>({value:v,label:OrderStatus(v)}));
    const _AccountTypeOptions = [{value:'1',label:'บริษัท'},{value:'2',label:'ร้าน'}];
    const _QuotationTypeOptions = QuotationType.map(v=>({value:String(v),label:QuotationTypeName(v)}));
    const [_PopoverTarget,setPopoverTarget] = useState(null);
    const [_PopoverEvent,setPopoverEvent] = useState(null);
    useEffect(() => {
        (async () => {
            //await _LoadQuotationStatus();
        })();

        return ()=>{ }
    }, []);
    const handleEventClick = (arg) => {
        if(arg.event._def.extendedProps.CalendarID === undefined) return;
        API({method:"get",url:"/Calendar/Event/"+arg.event._def.extendedProps.CalendarID}).then(res=>{
            if (!res.data.status) {
                return;
            }
            setPopoverEvent({
                CalendarID: arg.event._def.extendedProps.CalendarID,
                Title: arg.event.title,
                start: res.data.data.calendarStart,
                end: res.data.data.calendarEnd,
                Color: arg.event.backgroundColor,
            });
            setPopoverTarget(arg.el);
        }).catch(res => {
            return;
        });        
    }
    const _ClosePopover = () => {
        setPopoverTarget(null);
        setPopoverEvent(null);
    }
    const _ShowEventDetail = () => {
        const _CalendarID = _PopoverEvent?.CalendarID;
        _ClosePopover();
        if(_CalendarID === undefined) return;
        _GetEvent(_CalendarID);
    }
    const _ChangeEventColor = (Hex) => {
        const _CalendarID = _PopoverEvent?.CalendarID;
        if(_CalendarID === undefined) return;
        setPopoverEvent(p=>({...p,Color:Hex}));
        API({method:"put",url:"/Calendar/Event/"+_CalendarID+"/Color",data:{Color:Hex.replace('#','')}}).then(res=>{
            if (!res.data.status) {
                Swal.fire({ icon: 'error', title: res.data.message });
                return;
            }
            setEventList(prev=>prev.map(ev=>ev.CalendarID===_CalendarID?{...ev,backgroundColor:Hex,borderColor:Hex}:ev));
            //_LoadEvent(_DateInfo.start,_DateInfo.end);
        }).catch(res => {
            Swal.fire({ icon: 'error', title: res.data?.message||'บันทึกสีไม่สำเร็จ' });
        });
    }
    const _Search = async() =>{
        _LoadEvent(_DateInfo.start, _DateInfo.end);
    }
    const _LoadEvent = async(Start,End)=>{
        Swal.showLoading();
        API({method : "get",url:"/Calendar/Event?StartDate="+DateFormatJSON(Start,false)+'&EndDate='+DateFormatJSON(End,false)+'&CalendarType='+(_QuotationType.length>0?_QuotationType.join(','):0)+'&AccountType='+(_AccountType.length>0?_AccountType.join(','):0)+'&CalendarStatus='+(_OrderStatusList.length>0?_OrderStatusList.join(','):0)}).then(res=>{
            if (res.status !== 200) {
                Swal.close();
                return;
            }
    
            if (!res.data.status) {
                Swal.close();
                return;
            }
            
            setEventList(res.data.data);
            Swal.close();
        }).catch(res => {
            Swal.fire({
                icon: 'error',
                title: res.data.message,
            });
            return;
        });
    }

    const _GetEvent = async(CalendarID) =>{
        Swal.showLoading();
        API({method : "get",url:"/Calendar/Event/"+CalendarID}).then(res=>{
            if (res.status !== 200) {
                Swal.close();
                return;
            }
    
            if (!res.data.status) {
                Swal.close();
                return;
            }
            Swal.close();
            switch(res.data.data.refType){
                case 'QEVEN':
                    _LoadOrderEvent(res.data.data.refId);
                break;
            }
        }).catch(res => {
            Swal.close();
            return;
        });
    }

    
    const _LoadOrderEvent = async(QuotationEventID) =>{
        Swal.showLoading();
        API({method : "get",url:"/Order/Quotation/Event/"+QuotationEventID}).then(res=>{
            Swal.close();
            if (res.status !== 200) {
                return;
            }
            if (!res.data.status) {
                return;
            }
            _OrderInfoCard.current?.Show(res.data.data.orderId);
        }).catch(res => {
            Swal.close();
            return;
        });
    }

    const _LoadQuotationEvent = async(QuotationEventID) =>{
        Swal.showLoading();
        API({method : "get",url:"/Quotation/Event/"+QuotationEventID}).then(res=>{
            Swal.close();
            if (res.status !== 200) {
                return;
            }
            if (!res.data.status) {
                return;
            }
            _QuotationInfoCard.current?.Show(res.data.data.quotationId);
        }).catch(res => {
            Swal.close();
            return;
        });
    }
    return (
        <>
        <React.Fragment>
            <div className='container-fluid'>
                <div className='row mt-2 mb-2 justify-content-end'>
                    <div className='col-lg-2 mt-2'>
                        <Select
                            className='w-100'
                            isMulti
                            placeholder='ประเภทบัญชี'
                            options={_AccountTypeOptions}
                            value={_AccountTypeOptions.filter(o=>_AccountType.includes(o.value))}
                            onChange={(selected)=>{setAccountType(selected?selected.map(s=>s.value):[]);}}
                            noOptionsMessage={()=>'ไม่พบข้อมูล'}
                        />
                    </div>
                    <div className='col-lg-2 mt-2'>
                        <Select
                            className='w-100'
                            isMulti
                            placeholder='ประเภทงาน'
                            options={_QuotationTypeOptions}
                            value={_QuotationTypeOptions.filter(o=>_QuotationType.includes(o.value))}
                            onChange={(selected)=>{setQuotationType(selected?selected.map(s=>s.value):[]);}}
                            noOptionsMessage={()=>'ไม่พบข้อมูล'}
                        />
                    </div>
                    <div className='col-lg-3'>
                        <div className="input-group mb-3">
                            <Select
                                className='w-100'
                                isMulti
                                placeholder='สถานะ'
                                options={_OrderStatusOptions}
                                value={_OrderStatusOptions.filter(o=>_OrderStatusList.includes(o.value))}
                                onChange={(selected)=>{setOrderStatusList(selected?selected.map(s=>s.value):[]);}}
                                noOptionsMessage={()=>'ไม่พบข้อมูล'}
                            />
                        </div>
                    </div>
                    <div className='col-lg-1 text-end'>
                        <button type='button' style={{'width':'80px'}} className='btn btn-info text-white' onClick={()=>{_Search();}}>ค้นหา</button>
                    </div>
                </div>
                <div className='row justify-content-end align-items-center mb-2'>
                    {_CalendarView!=='dayGridMonth' && <div className='col-auto'>
                        <input
                            type='date'
                            className='form-control'
                            onChange={(e)=>{
                                if(!e.target.value) return;
                                _CalendarRef.current?.getApi().gotoDate(e.target.value);
                            }}
                        />
                    </div>}
                    <div className='col-auto'>
                        <div className='btn-group'>
                            <button type="button" className={`btn ${_CalendarView==='dayGridMonth'?'btn-success':'btn-outline-success'}`} onClick={()=>{ setCalendarView('dayGridMonth'); _CalendarRef.current?.getApi().changeView('dayGridMonth'); }}>เดือน</button>
                            <button type="button" className={`btn ${_CalendarView==='timeGridWeek'?'btn-success':'btn-outline-success'}`} onClick={()=>{ setCalendarView('timeGridWeek'); _CalendarRef.current?.getApi().changeView('timeGridWeek'); }}>สัปดาห์</button>
                            <button type="button" className={`btn ${_CalendarView==='timeGridDay'?'btn-success':'btn-outline-success'}`} onClick={()=>{ setCalendarView('timeGridDay'); _CalendarRef.current?.getApi().changeView('timeGridDay'); }}>วัน</button>
                        </div>
                    </div>
                </div>
                <div className='row mt-2'>
                    <div className='col-lg-12'>
                        <FullCalendar
                        ref={_CalendarRef}
                        plugins={[ dayGridPlugin,timeGridPlugin,interactionPlugin ]}
                        locale={thLocale}
                        initialView="dayGridMonth"
                        eventClick={handleEventClick}
                        datesSet={(dateInfo) => {
                            setDateInfo({...dateInfo});
                            _LoadEvent(dateInfo.start,dateInfo.end);
                        }}
                        events={_EventList}
                        />
                    </div>
                </div>
            </div>
            <Overlay show={!!_PopoverTarget} target={_PopoverTarget} placement='top' rootClose onHide={_ClosePopover}>
                {(overlayProps)=>(
                    <Popover {...overlayProps} id='calendar-event-popover'>
                        <Popover.Header as='h3' className='d-flex align-items-center gap-2'>
                            <span style={{display:'inline-block',width:10,height:10,borderRadius:2,backgroundColor:_PopoverEvent?.Color||'#6c757d',flexShrink:0}}></span>
                            <span>{_PopoverEvent?.Title}</span>
                        </Popover.Header>
                        <Popover.Body>
                            <div>เริ่ม: {DateThaiFormat(_PopoverEvent?.start,true)}</div>
                            <div>สิ้นสุด: {DateThaiFormat(_PopoverEvent?.end,true)}</div>
                            <div className='d-flex align-items-center gap-2 mt-2'>
                                <label className='mb-0'>สี:</label>
                                <input
                                    type='color'
                                    className='form-control form-control-color p-0'
                                    style={{width:36,height:28}}
                                    value={_PopoverEvent?.Color||'#6c757d'}
                                    onChange={(e)=>_ChangeEventColor(e.target.value)}
                                />
                            </div>
                            <div className='mt-2 text-end'>
                                <button type='button' className='btn btn-sm btn-info text-white' onClick={_ShowEventDetail}>ดูรายละเอียด</button>
                            </div>
                        </Popover.Body>
                    </Popover>
                )}
            </Overlay>
        </React.Fragment>
        <QuotationInfoCard ref={_QuotationInfoCard}/>
        <OrderCardInfo ref={_OrderInfoCard} callback={()=>{_LoadEvent(_DateInfo.start,_DateInfo.end);}}/>
        </>
    )
}
export default React.memo(PageCalendar)